import type { Route } from "./+types/route";
import Landing from "./components/Home/Home";
import {
  generateSeoMeta,
  generateOrganizationSchema,
  generateWebApplicationSchema,
  generateWebSiteSchema,
} from "~/common/utils/seo-meta";

export function meta({}: Route.MetaArgs) {
  return [
    ...generateSeoMeta({
      title: "Brandly - Контроль торгових марок",
      description:
        "Brandly — система контролю торгових марок. Вводите номер — система знаходить статус у реєстрі, показує стан діловодства й підказує, що робити далі. Нагадує про дедлайни в Telegram.",
      keywords: [
        "brandly",
        "брендлі",
        "торгові марки",
        "контроль заявок",
        "УКРНОІВІ",
        "реєстр торгових марок",
        "моніторинг торгових марок",
        "управління брендом",
      ],
      canonicalUrl: "/",
    }),
    generateOrganizationSchema(),
    generateWebApplicationSchema(),
    generateWebSiteSchema(),
  ];
}

export default function LandingRoute() {
  return <Landing />;
}
